import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "backCrumb23" }
const _hoisted_2 = { class: "addProEdit" }
const _hoisted_3 = { class: "through" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  class: "proList23"
}
const _hoisted_6 = {
  cellpadding: "0",
  cellspacing: "1",
  border: "0"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "wD120" }, "产品图片"),
  /*#__PURE__*/_createElementVNode("th", { class: "wD160" }, "产品名称"),
  /*#__PURE__*/_createElementVNode("th", { class: "wD200" }, "产品简介"),
  /*#__PURE__*/_createElementVNode("th", { class: "wD180" }, "更新时间"),
  /*#__PURE__*/_createElementVNode("th", { class: "wD120" }, "审核状态"),
  /*#__PURE__*/_createElementVNode("th", { class: "wD120" }, "操作")
], -1)
const _hoisted_8 = { class: "wD120" }
const _hoisted_9 = { class: "proIm23" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "wD160" }
const _hoisted_12 = { class: "wD200" }
const _hoisted_13 = ["textContent"]
const _hoisted_14 = ["textContent"]
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "wD120" }
const _hoisted_17 = { class: "proEdit" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", { href: "javascript:;" }, "删除", -1)
const _hoisted_19 = {
  key: 0,
  class: "backPage"
}
const _hoisted_20 = {
  key: 1,
  class: "noInfo"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createElementVNode("img", { src: "/images/back/default_col@2x.png" })
], -1)

import { reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import {
  productListInfo,
  ProductService,
  ProductParams,
  productStateNumber,
} from "@/api/product";
import { ElMessage } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const route = useRoute();

const state = reactive({
  list: [] as productListInfo[],
  records: 0,
  stateInfo: {} as productStateNumber,
  params: {
    auditStatus: 2,
    pageIndex: 1,
    pageSize: 10,
  } as ProductParams,
  loadingState: true,
  ddlShow: false,
  ddlText: "已通过",
});

const init = async () => {
  if (!isNaN(Number(route.query.state))) {
    const stateQuery = Number(route.query.state);
    if (stateQuery === 1 || stateQuery === 2 || stateQuery === 3) {
      state.params.auditStatus = stateQuery;
      switch (stateQuery) {
        case 1:
          state.ddlText = `审核中`;
          break;
        case 2:
          state.ddlText = `已审核`;
          break;
        case 3:
          state.ddlText = `未审核`;
          break;
      }
    }
  }
  handleList();
};

const handleList = async () => {
  state.loadingState = true;
  await ProductService.products(state.params).then((response) => {
    state.list = response.data.list;
    state.records = response.data.records;
  });

  await ProductService.stateNumber().then((response) => {
    state.stateInfo = response.data;
  });
  state.loadingState = false;
};

// 切换产品列表
const switchState = async (auditStatus: number, ddlText: string) => {
  state.params.pageIndex = 1;
  state.params.auditStatus = auditStatus;
  state.ddlShow = false;
  state.ddlText = ddlText;
  handleList();
};

const handelDel = async (productId: number) => {
  await ProductService.delete(productId).then(() => {
    ElMessage.success("删除成功");
    handleList();
  });
};

const handleCurrentChange = async (currentPageNumber: number) => {
  state.params.pageIndex = currentPageNumber;
  handleList();
};

onMounted(init);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("公司信息")
        ]),
        _: 1
      }),
      _createTextVNode(" > 产品案例 ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: "javascript:;",
          class: "throughArrow",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (state.ddlShow = !state.ddlShow))
        }, [
          _createElementVNode("span", {
            textContent: _toDisplayString(state.ddlText)
          }, null, 8, _hoisted_4)
        ]),
        _withDirectives(_createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (switchState(1, '审核中')))
            }, "审核中")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (switchState(2, '已通过')))
            }, "已通过")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (switchState(3, '未通过')))
            }, "未通过")
          ])
        ], 512), [
          [_vShow, state.ddlShow]
        ])
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_router_link, { to: "/product/create" }, {
          default: _withCtx(() => [
            _createTextVNode("新增 ")
          ]),
          _: 1
        })
      ])
    ]),
    (state.records > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.list, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("img", {
                        src: item.imagePath
                      }, null, 8, _hoisted_10)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      to: `/product/` + item.productId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.productName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("p", {
                      class: "proDein23",
                      textContent: _toDisplayString(item.applicationType)
                    }, null, 8, _hoisted_13)
                  ]),
                  _createElementVNode("td", {
                    class: "wD180",
                    textContent: _toDisplayString(item.updateDate)
                  }, null, 8, _hoisted_14),
                  _createElementVNode("td", {
                    class: "wD120",
                    textContent: _toDisplayString(item.auditStatusText)
                  }, null, 8, _hoisted_15),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_router_link, {
                        to: `/product/` + item.productId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_el_popconfirm, {
                        "confirm-button-text": "删除",
                        "cancel-button-text": "取消",
                        "icon-color": "red",
                        title: "确认要删除？",
                        onConfirm: ($event: any) => (handelDel(item.productId))
                      }, {
                        reference: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 2
                      }, 1032, ["onConfirm"])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          (state.records > state.params.pageSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_el_pagination, {
                  background: "",
                  layout: "prev, pager, next",
                  onCurrentChange: handleCurrentChange,
                  total: state.records
                }, null, 8, ["total"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("p", null, [
            _createTextVNode(" 贵公司还未上传产品案例，"),
            _createVNode(_component_router_link, { to: "/product/create" }, {
              default: _withCtx(() => [
                _createTextVNode("点此添加")
              ]),
              _: 1
            })
          ])
        ]))
  ])), [
    [_directive_loading, state.loadingState]
  ])
}
}

})